module.exports = __webpack_public_path__ + "static/media/1.18a4c94d.jpg";